import {BaseApi} from "@/http/api/BaseApi";
import {BrandDetailsApiResponse, BrandsApiResponse} from "@/types/api/brand";
import {IGetBrandsService} from "@/interface/api/brand";

export default class GetBrandsService extends BaseApi implements IGetBrandsService {


    getBrands = async ({params, buildUrl}: { params?: any, buildUrl?: boolean  }): Promise<BrandsApiResponse> => {
        if (buildUrl) {
            let url = this.urlBuilder(`brands`, params);
            return this.get(url);
        } else {
            return this.get(`brands?${params}`);
        }
    };


    getBrand = async ({slug, params}: { slug: string; params?: any }): Promise<BrandDetailsApiResponse> => {
        const url = this.urlBuilder(`brands/catalog/${slug}`, {...params});
        return this.get(url, {
            next: {
                revalidate: 60000,
                tags: ["brand" , slug , params],
            },
        });
    };


    getBrandById = async (id: number | string): Promise<BrandDetailsApiResponse> => {
        const url = `brands/${id}`;
        return this.get(url, {
            next: {
                revalidate: 60000,
                tags: ["brand"],
            },
        });
    };

}
